import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/** @jsx jsx */


import { jsx } from 'theme-ui';
import Iframe from 'react-frame-component';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CLEAR_PADDING = "<style> body { padding: 0; margin: 0; }  </style>";
var INITIAL_IFRAME_CONTENT = "<!DOCTYPE html><html><head> " + CLEAR_PADDING + " </head><body><div></div></body></html>";
export var IframeWrapper = function IframeWrapper(_ref) {
  var children = _ref.children,
      height = _ref.height,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return jsx(Iframe, {
    initialContent: INITIAL_IFRAME_CONTENT,
    sx: _objectSpread({}, styles.previewInner(), {
      height: height
    }, style)
  }, children);
};

if (typeof IframeWrapper !== 'undefined' && IframeWrapper && IframeWrapper === Object(IframeWrapper) && Object.isExtensible(IframeWrapper) && !IframeWrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(IframeWrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "IframeWrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/IframeWrapper.js"
    }
  });
}